"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var minWidth = 50;

var styles = function styles(_a) {
  var x6 = _a.x6,
      colorBgSecondary = _a.colorBgSecondary;
  return {
    wrapper: {
      width: 'inherit',
      display: 'inline-block',
      verticalAlign: 'middle',
      minWidth: minWidth + "px",
      position: 'relative',
      '& > *': {
        height: x6 + "px",
        lineHeight: x6 + "px",
        backgroundColor: colorBgSecondary.normal,
        minWidth: minWidth + "px"
      },
      '& > *:hover': {
        height: x6 + "px",
        lineHeight: x6 + "px",
        backgroundColor: colorBgSecondary.hover
      }
    },
    active: {
      '& > *': {
        backgroundColor: colorBgSecondary.active
      }
    },
    hideSelect: {
      '& > *:first-child': {
        height: 0,
        outline: 0,
        visibility: 'hidden'
      }
    },
    progress: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top: 0,
      left: 0,
      fallbacks: [{
        display: '-ms-flexbox',
        '-ms-flex-align': 'center',
        '-ms-flex-pack': 'center',
        '-ms-flex-direction': 'row'
      }, {
        display: '-webkit-box',
        '-webkit-box-align': 'center',
        '-webkit-box-pack': 'center',
        '-webkit-box-orient': 'horizontal',
        '-webkit-box-direction': 'normal'
      }, {
        display: '-webkit-flex',
        '-webkit-align-items': 'center',
        '-webkit-justify-content': 'center',
        '-webkit-flex-direction': 'row'
      }]
    }
  };
};

exports.default = styles;